import 'css-chunksrc/feature/check/CheckPanelFooter.module.scss';export default {
  "root": "CheckPanelFooter_root",
  "viewModeMain": "CheckPanelFooter_viewModeMain",
  "checkDetails": "CheckPanelFooter_checkDetails",
  "viewModeOverlay": "CheckPanelFooter_viewModeOverlay",
  "overlayContainer": "CheckPanelFooter_overlayContainer",
  "handle": "CheckPanelFooter_handle",
  "total": "CheckPanelFooter_total",
  "actions": "CheckPanelFooter_actions",
  "overlayContent": "CheckPanelFooter_overlayContent",
  "checkDetailsMore": "CheckPanelFooter_checkDetailsMore",
  "checkDetailsMoreGrid": "CheckPanelFooter_checkDetailsMoreGrid",
  "checkDetailsMoreCloseBtn": "CheckPanelFooter_checkDetailsMoreCloseBtn"
};